import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function searchActivities(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    activityId,
    productId,
    crawlingId,
    facilityId,
    afterAt,
    beforeAt
  } = filters;

  const params = {
    'Order.By': 'CreatedAt',
    'Order.Direction': 'Desc',
    'Paging.Number': skipPages || 1,
    'Paging.Count': resultsCount,
    ActivityId: activityId || undefined,
    ProductId: productId || undefined,
    CrawlingId: crawlingId || undefined,
    FacilityId: facilityId || undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined
  };

  return wsRequestGet('/admin/activities/search', language, timeZone, params, cancelToken);
}

export async function getActivity(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/activities/${id}`, language, timeZone, null, cancelToken);
}

export async function runBookingCheck( language, timeZone, cancelToken) {
  try {
    wsRequestGet(`/admin/scheduler/run-booking-check`, language, timeZone, null, cancelToken);
    return {
      success: true
    };
  } catch (error) {
    return {
      success: false
    };
  }
  
}

export async function cleanActivitiesForProduct(productId, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/activities/${productId}/clean-product`, language, timeZone, null, null, cancelToken);
}

export async function cleanActivitiesForIntegration(productId, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/activities/${productId}/clean-integration`, language, timeZone, null, null, cancelToken);
}

export async function cleanOldActivities(language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/activities/clean-outdated`, language, timeZone, null, null, cancelToken);
}
